import api from './authApi';

/**
 * Get lectures with optional filtering
 */
export const getLectures = async (params = {}) => {
  try {
    const response = await api.get('/lectures', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching lectures:', error);
    throw error;
  }
};

/**
 * Get lectures for a specific module
 */
export const getLecturesForModule = async (moduleId, params = {}) => {
  try {
    const response = await api.get(`/modules/${moduleId}/lectures`, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching module lectures:', error);
    throw error;
  }
};

/**
 * Get lecture details by ID
 */
export const getLectureDetails = async (lectureId) => {
  try {
    const response = await api.get(`/lectures/${lectureId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching lecture details:', error);
    throw error;
  }
};

/**
 * Create a new lecture
 */
export const createLecture = async (lectureData) => {
  try {
    const response = await api.post('/lectures', lectureData);
    return response.data;
  } catch (error) {
    console.error('Error creating lecture:', error);
    throw error;
  }
};

/**
 * Update lecture information
 */
export const updateLecture = async (lectureId, data) => {
  try {
    const response = await api.patch(`/lectures/${lectureId}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating lecture:', error);
    throw error;
  }
};

/**
 * Update meeting link for a lecture
 */
export const updateMeetingLink = async (lectureId, meetingData) => {
  try {
    const response = await api.patch(`/lectures/${lectureId}/meeting`, meetingData);
    return response.data;
  } catch (error) {
    console.error('Error updating meeting link:', error);
    throw error;
  }
};

/**
 * Schedule multiple lectures at once
 */
export const scheduleLectures = async (scheduleData) => {
  try {
    const response = await api.post('/lectures/schedule', scheduleData);
    return response.data;
  } catch (error) {
    console.error('Error scheduling lectures:', error);
    throw error;
  }
};

/**
 * Get upcoming lectures
 */
export const getUpcomingLectures = async (params = {}) => {
  try {
    const response = await api.get('/lectures/upcoming', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching upcoming lectures:', error);
    throw error;
  }
};

/**
 * Delete a lecture
 */
export const deleteLecture = async (lectureId) => {
  try {
    const response = await api.delete(`/lectures/${lectureId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting lecture:', error);
    throw error;
  }
};

export const lectureApi = {
  getLectures,
  getLecturesForModule,
  getLectureDetails,
  createLecture,
  updateLecture,
  updateMeetingLink,
  scheduleLectures,
  getUpcomingLectures,
  deleteLecture,
};

export default lectureApi;